<template>
  <div
    class="selection-shadow flex w-full cursor-pointer items-center justify-between rounded-[10px] border bg-white px-[16px] py-[15px] transition-colors hover:bg-[#f9f9fa]"
    :class="selected ? 'border-gray-800' : 'border-black/[0.08]'"
    @click="handleClick"
  >
    <div class="flex min-w-0 items-center gap-[12px]">
      <component
        :is="icon"
        class="size-[18px] shrink-0 text-gray-800"
        aria-hidden="true"
      />
      <span
        class="truncate text-[14px] leading-[18px] text-gray-800"
        :class="selected ? 'font-medium' : 'font-normal'"
      >
        <slot />
      </span>
    </div>

    <Checkbox
      v-if="multiple"
      :model-value="selected"
      class="pointer-events-none shrink-0"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'

import { Checkbox } from '@dacr/library'

const props = defineProps<{
  modelValue: string | string[]
  icon: Component
  value: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | string[]): void
}>()

const multiple = computed(() => Array.isArray(props.modelValue))

const selected = computed(() =>
  multiple.value
    ? (props.modelValue as string[]).includes(props.value)
    : props.modelValue === props.value
)

const handleClick = () => {
  if (!multiple.value) {
    emit('update:modelValue', props.value)
    return
  }

  const current = props.modelValue as string[]
  emit(
    'update:modelValue',
    current.includes(props.value)
      ? current.filter((val) => val !== props.value)
      : [...current, props.value]
  )
}
</script>

<style scoped>
.selection-shadow {
  box-shadow:
    0 0.8px 2.925px 0 rgba(0, 0, 0, 0.02),
    0 2.025px 7.8px 0 rgba(0, 0, 0, 0.004),
    0 4px 18px 0 rgba(0, 0, 0, 0.04);
}
</style>
